import { useEffect, useRef, useState } from 'react';
import { defaultSelectedValue } from './base-select';
const getOptionResults = (searchTerm, optionsGroups, canSearchSubText = false) => optionsGroups.reduce((results, group) => {
    const matchedOptions = group.options.filter((option) => {
        var _a;
        let searchText = (_a = option.label) !== null && _a !== void 0 ? _a : '';
        if (canSearchSubText) {
            searchText += option.subText;
        }
        return searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase().includes(searchTerm.toLowerCase());
    });
    if (!matchedOptions.length && !group.emptyState) {
        return results;
    }
    const { title = '', titleButton = undefined, emptyState = '' } = group;
    return results.concat({
        title,
        titleButton,
        emptyState,
        options: matchedOptions,
    });
}, []);
export const useSelect = (show, optionsGroups, onSearchInput, defaultSelected = defaultSelectedValue, canSearchSubText) => {
    const [visible, setVisible] = useState(show);
    const [selectedValue, setSelectedValue] = useState(defaultSelected);
    const [searchTerm, setSearchTerm] = useState('');
    const [optionsResults, setOptionsResults] = useState(optionsGroups);
    const onSearchInputRef = useRef(onSearchInput);
    onSearchInputRef.current = onSearchInput;
    // Notify the parent ONLY when the user's search term actually changes.
    useEffect(() => {
        var _a;
        (_a = onSearchInputRef.current) === null || _a === void 0 ? void 0 : _a.call(onSearchInputRef, searchTerm);
    }, [searchTerm]);
    // Keep displayed results in sync: when the parent owns search
    // (onSearchInput provided) show its options as-is; otherwise filter locally.
    useEffect(() => {
        if (onSearchInput) {
            setOptionsResults(optionsGroups);
            return;
        }
        setOptionsResults(getOptionResults(searchTerm, optionsGroups, canSearchSubText));
    }, [onSearchInput, optionsGroups, searchTerm, canSearchSubText]);
    return {
        visible,
        setVisible,
        selectedValue,
        setSelectedValue,
        searchTerm,
        setSearchTerm,
        optionsResults,
        setOptionsResults,
    };
};
//# sourceMappingURL=select-util.js.map